// @flow

import { graphql } from 'react-relay';
import createRelayMutation from 'shared/gql/createRelayMutation';

const mutation = graphql`
  mutation PostJournalEntryMutation($input: PostJournalEntryInput!) {
    postJournalEntry(input: $input) {
      journalEntryEdge {
        node {
          id
          status
          postedAt
        }
      }
    }
  }
`;

export default {
  commit: (options: Object) => {
    return createRelayMutation(mutation, { ...options });
  },
};
